import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/quoting_/quotes/")({
  beforeLoad: () => {
    throw redirect({ to: "/quotes" })
  },
})
